import { render } from "./Area-Sucursal-Component.vue?vue&type=template&id=5773d5c8&scoped=true"
import script from "./Area-Sucursal-Component.vue?vue&type=script&lang=js"
export * from "./Area-Sucursal-Component.vue?vue&type=script&lang=js"

import "./Area-Sucursal-Component.vue?vue&type=style&index=0&id=5773d5c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5773d5c8"]])

export default __exports__